import { TransactionList } from "../components/TransactionList";
import { TransactionFilters } from "../components/TransactionFilters";
import { useTransactionSearchParams } from "../components/hooks/useTransactionSearchParams";
import { Box } from "@mui/material";

export const TransactionListPage = () => {
  const { filters, setFilters } = useTransactionSearchParams();

  return (
    <Box>
      <TransactionFilters filters={filters} onFiltersChange={setFilters} />
      <TransactionList filters={filters} />
    </Box>
  );
};
